let requestRunning = false;
let cloudSaveRequestRunning = false;

let game = {};
game.settings = {};
game.powerupLevel1 = 'powerup_1_icon';
game.powerupLevel2 = 'powerup_2_icon';
game.powerupLevel3 = 'powerup_3_icon';
game.powerupWord = 'Artifact';

export const globalUser = {};
globalUser.settings = {};
globalUser.developerMode = location.hostname === "localhost";

let baseUrl = '';

export const globals = {
    requestRunning: requestRunning,
    cloudSaveRequestRunning: cloudSaveRequestRunning,
    game: game,
    currentTutorialStep: null,
    baseUrl: baseUrl,
};